let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kuj4R")).then(() => parcelRequire('eRvGI'));